














































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch, Emit } from "vue-property-decorator";
import { GetListByCode } from "@/api/configureDictionary";
import { GetKnowledgeList } from "@/api/pdOutPatient/pdEducation/pdKnowledge";
@Component({})
export default class PdEducationPlanDetailAdd extends AbpBase {
  @Prop() currentPlanDetail: any;
  split1: number = 0.3;
  formData: any = {
    type: 1,
    keyCode: "",
    dirCode: "",
    classCode: ""
  };
  loading: boolean = false;
  columns = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: "教材名称",
      key: "name"
    }
  ];
  KnowledgeGroup: any[] = [];
  data: any = [];
  selectedList: any = [];
  KnowledgeComponent: any = {};

  @Watch("currentPlanDetail", { immediate: false, deep: true })
  async getData() {
    this.selectedList=[];
    this.loading = true;
    var res = await GetKnowledgeList(this.KnowledgeComponent);
    this.data = res.objects;
    this.loading = false;
  }

  handleSelect(selection: any, row: any) {
    this.selectedList.push(row);
  }

  handleSelectCancel(selection: any, row: any) {
    this.selectedList.splice(
      this.selectedList.findIndex((x: any) => x.id == row.id),
      1
    );
  }

  handleSelectAll() {
    this.data.forEach((item: any) => {
      if (this.selectedList.findIndex((x: any) => x.id == item.id) == -1) {
        this.selectedList.push(item);
      }
    });
  }

  handleSelectAllCancel() {
    this.data.forEach((item: any) => {
      this.selectedList.splice(
        this.selectedList.findIndex((x: any) => x.id == item.id),
        1
      );
    });
  }

  initDic() {
    GetListByCode({ input: "PD_Knowledge_Group" }).then(res => {
      this.KnowledgeGroup = res;
      this.KnowledgeComponent.group = -1;
    });
  }
  onSubmit() {
    return this.selectedList;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdEducationPlan/parts/pdEducationPlan/pdEducationPlanDetailAdd.vue